export const PaymentMethodCategoryTypes = {
  US_DOMESTIC: 'US_DOMESTIC',
  CANADIAN_DOMESTIC: 'CANADIAN_DOMESTIC',
  INTERNATIONAL_US: 'INTERNATIONAL_US',
  EXTERNAL: 'EXTERNAL',
} as const

export type PaymentMethodCategoryType =
  (typeof PaymentMethodCategoryTypes)[keyof typeof PaymentMethodCategoryTypes]
